// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DocumentsWithProcessingJobsQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  documentIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type DocumentsWithProcessingJobsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string, name: string } | null } | null> | null } };

export const Operations = {
  Query: {
    DocumentsWithProcessingJobs: 'DocumentsWithProcessingJobs' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DocumentsWithProcessingJobsDocument = gql`
    query DocumentsWithProcessingJobs($householdId: ID!, $documentIds: [ID!]!) {
  documents(where: {hasHouseholdWith: [{id: $householdId}], idIn: $documentIds}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useDocumentsWithProcessingJobsQuery__
 *
 * To run a query within a React component, call `useDocumentsWithProcessingJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsWithProcessingJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsWithProcessingJobsQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useDocumentsWithProcessingJobsQuery(baseOptions: Apollo.QueryHookOptions<DocumentsWithProcessingJobsQuery, DocumentsWithProcessingJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsWithProcessingJobsQuery, DocumentsWithProcessingJobsQueryVariables>(DocumentsWithProcessingJobsDocument, withFetchPolicyContext(options));
      }
export function useDocumentsWithProcessingJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsWithProcessingJobsQuery, DocumentsWithProcessingJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsWithProcessingJobsQuery, DocumentsWithProcessingJobsQueryVariables>(DocumentsWithProcessingJobsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDocumentsWithProcessingJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentsWithProcessingJobsQuery, DocumentsWithProcessingJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentsWithProcessingJobsQuery, DocumentsWithProcessingJobsQueryVariables>(DocumentsWithProcessingJobsDocument, withFetchPolicyContext(options));
        }
export type DocumentsWithProcessingJobsQueryHookResult = ReturnType<typeof useDocumentsWithProcessingJobsQuery>;
export type DocumentsWithProcessingJobsLazyQueryHookResult = ReturnType<typeof useDocumentsWithProcessingJobsLazyQuery>;
export type DocumentsWithProcessingJobsSuspenseQueryHookResult = ReturnType<typeof useDocumentsWithProcessingJobsSuspenseQuery>;
export type DocumentsWithProcessingJobsQueryResult = Apollo.QueryResult<DocumentsWithProcessingJobsQuery, DocumentsWithProcessingJobsQueryVariables>;